
import Vue from "vue";

export default Vue.extend({
  name: "AuthErrorPage",
  data() {
    return {
      countdown: 5,
      timer: null as ReturnType<typeof setInterval> | null,
    };
  },
  computed: {
    isExpired(): boolean {
      const { type, endDate } = this.$route.query;
      return type === "expired" || (!type && !!endDate);
    },
    title(): string {
      return (this as any).isExpired ? "Subscription Expired" : "No Company Access";
    },
    message(): string {
      if ((this as any).isExpired) {
        return `Your company's subscription has expired on ${
          (this as any).formattedDate
        }.<br />Please contact your administrator to renew the subscription.`;
      }
      return "You are not assigned to any company.<br />Please contact your administrator.";
    },
    formattedDate(): string {
      const d = this.$route.query.endDate as string;
      if (!d) return "-";
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const dt = new Date(d);
      return `${String(dt.getDate()).padStart(2, "0")} ${monthNames[dt.getMonth()].substring(0, 3)} ${dt.getFullYear()}`;
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.countdown -= 1;
      if (this.countdown <= 0) {
        clearInterval(this.timer!);
        (this as any).$dep.authUseCase.logout();
      }
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
});
